(function () {
    function isQuickAddOpen() {
      const modalContent = document.querySelector('#Product-Info-product-quick-add-modal');
      if (!modalContent) return false;
  
      const rect = modalContent.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
    }
  
    function isStickyAtcVisible() {
      return !!document.querySelector('sticky-add-to-cart.show');
    }
  
    function updateFloatState() {
      document.body.classList.toggle('cz-quick-add-open', isQuickAddOpen());
      document.body.classList.toggle('cz-sticky-atc-visible', isStickyAtcVisible());
    }
  
    document.addEventListener('click', function () {
      setTimeout(updateFloatState, 100);
      setTimeout(updateFloatState, 400);
    });
  
    document.addEventListener('scroll', updateFloatState, { passive: true });
    window.addEventListener('resize', updateFloatState);
  
    new MutationObserver(updateFloatState).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'open', 'aria-hidden']
    });
  
    setInterval(updateFloatState, 200);
  
    updateFloatState();
  })();